var _objectSpread = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectSpread2").default;
var _objectWithoutProperties = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectWithoutProperties").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "width": "20",
        "height": "20",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs)
    }, rest), children.concat([_c('path', {
      attrs: {
        "d": "M17.5 16.875a.625.625 0 110 1.25h-15a.625.625 0 110-1.25h15zM16.325 2.546l.295.295a2.292 2.292 0 010 3.243l-8.44 8.434c-.42.419-.948.71-1.526.84l-2.974.668a.625.625 0 01-.737-.787l.846-2.869c.148-.501.42-.957.789-1.326l8.502-8.498a2.295 2.295 0 013.245 0zm-3.897 2.42l-6.966 6.962a1.875 1.875 0 00-.472.796l-.546 1.848 1.935-.434c.347-.078.664-.253.916-.504l6.903-6.899-1.77-1.768zm1.537-1.535l-.652.652 1.77 1.768.652-.652a1.042 1.042 0 000-1.474l-.295-.294a1.043 1.043 0 00-1.475 0z",
        "fill": "var(--mainColor)",
        "fill-rule": "nonzero"
      }
    })]));
  }
};